export const isCrossBorderHost = (host: string): boolean =>
  host.includes("tiktokglobalshop") ||
  host.includes("tiktokshopglobalselling") ||
  host.includes("seller-global");

export const isCrossBorderSite =
  typeof window !== "undefined" && isCrossBorderHost(window.location.host);

export const getCustomerFetchHostByHostname = (
  hostname = typeof window !== "undefined" ? window.location.hostname : ""
): string | undefined => {
  if (hostname.includes("seller.eu.tiktokglobalshop.com")) {
    return "https://api16-normal-no1a.tiktokglobalshop.com";
  }

  if (hostname.includes("seller.eu.tiktokshopglobalselling.com")) {
    return "https://api16-normal-no1a.tiktokshopglobalselling.com";
  }

  if (hostname.includes("seller.us.tiktokglobalshop.com")) {
    return "https://seller.us.tiktokglobalshop.com";
  }

  if (hostname.includes("seller.us.tiktokshopglobalselling.com")) {
    return "https://seller.us.tiktokshopglobalselling.com";
  }

  if (hostname.includes("seller-global.tiktok.com")) {
    return "https://api-global.tiktok.com";
  }

  if (hostname.includes("seller-global-eu.tiktok.com")) {
    return "https://api-global-eu.tiktok.com";
  }

  if (hostname.includes("seller-global-us.tiktok.com")) {
    return "https://api-global-us.tiktok.com";
  }

  return undefined;
};
